const initialState = {
  email: '',
  prefilledEmail: '',
  password: '',
  loading: false,
  error: null,
  fieldErrors: {},
  fieldWarnings: {},
  allowCorporateLogin: false,
  requestPassword: false,
  requestTOTP: false,
  totpSessionChallenge: null,
  captchaType: null,
  cgCaptchaValue: '',
  cgcaptcha: {
    id: '',
    imageUrl: '',
    loading: false,
  },
  RequiredPasswordUpdate: false,
  RequiredProfileUpdate: false,
};

/* eslint-disable complexity */
export default function (state = initialState, payload) {
  switch (payload.type) {
    case 'LOGIN_INPUT_CHANGE':
      // eslint-disable-next-line no-prototype-builtins
      if (!initialState.hasOwnProperty(payload.data.id)) {
        return state;
      }
      return { ...state, [payload.data.id]: payload.data.value };
    case 'LOGIN_INPUT_CHANGE#WARN':
      return { ...state, fieldWarnings: payload.fieldWarnings || {} };
    case 'PREFILL_EMAIL':
      return { ...state, prefilledEmail: payload.email };
    case 'LOGIN_RESET':
      return { ...initialState, email: state.prefilledEmail };
    case 'SUBMIT_LOGIN':
      return { ...state, loading: true };
    case 'SUBMIT_LOGIN#COMPLETE':
      return {
        ...state,
        error: null,
        loading: false,
        RequiredPasswordUpdate: payload.data.RequiredPasswordUpdate,
        RequiredProfileUpdate: payload.data.RequiredProfileUpdate,
      };
    case 'SUBMIT_LOGIN#ERROR':
      return { ...state, password: '', fieldErrors: payload.fieldErrors || {}, error: payload.error, loading: false };
    case 'RESEND_ACTIVATION_CODE#COMPLETE':
      return { ...state, error: null };
    case 'ALLOW_CORPORATE_LOGIN':
      return { ...state, allowCorporateLogin: payload.allowCorporateLogin };
    case 'REQUEST_PASSWORD':
      return { ...state, requestPassword: payload.requestPassword };
    case 'REQUEST_TOTP':
      return {
        ...state,
        requestTOTP: payload.requestTOTP,
        totpSessionChallenge: payload.challenge || null,
        loading: false,
      };
    case 'SET_LOADING':
      return { ...state, loading: payload.loading };
    case 'GENERATE_LOGIN_CG_CAPTCHA#START':
      return {
        ...state,
        cgcaptcha: {
          ...state.cgcaptcha,
          loading: true,
        },
      };
    case 'GENERATE_LOGIN_CG_CAPTCHA#COMPLETE':
      return {
        ...state,
        cgcaptcha: {
          id: payload.data.id,
          imageUrl: `//${window.CG_CAPTCHA_DOMAIN}${payload.data.image}`,
          loading: false,
        },
      };
    case 'SET_LOGIN_CAPTCHA_TYPE':
      return {
        ...state,
        captchaType: payload.captchaType,
      };
    default:
      return state;
  }
}
/* eslint-enable complexity */
